import { useNavigateToModal } from '@/config/routes'
import { ReactNode, MouseEvent } from 'react'

interface Props {
  to: string
  onOpen?: () => void
  className?: string
  children?: ReactNode
  replace?: boolean
}
export const GlobalModalLink = ({
  to,
  onOpen,
  className,
  children,
  replace = false
}: Props) => {
  const navigate = useNavigateToModal()

  const handleClick = (event: MouseEvent) => {
    event.preventDefault()

    navigate(to, { replace: replace })
    onOpen?.()
  }

  return (
   <a
     href={to}
     className={className}
     onClick={handleClick}
   >
     {children}
   </a>
 )
}
